import { createSlice, isAnyOf, type PayloadAction } from '@reduxjs/toolkit';
import { proposalsApi } from 'features/proposal/query';
import { type ProposalState, type TProposalDetail } from 'features/proposal/types';

const initialState: ProposalState = {
  proposalDetail: null,
  isFetchingProposalDetail: false,
  proposalTypes: [],
  isFetchingProposalTypes: false,
  proposalComments: null,
};

const proposalSlice = createSlice({
  name: 'proposal',
  initialState,
  reducers: {
    setProposalDetail: (
      state,
      action: PayloadAction<TProposalDetail | null>
    ) => {
      state.proposalDetail = action.payload;
    },
  },
  extraReducers: builder => {
    const { GetProposalDetail, GetAllProposalTypes, GetProposalComments } =
      proposalsApi.endpoints;

    builder
      .addMatcher(GetProposalDetail.matchPending, state => {
        state.proposalDetail = null;
        state.isFetchingProposalDetail = true;
      })
      .addMatcher(GetProposalDetail.matchFulfilled, (state, { payload }) => {
        state.proposalDetail = payload;
        state.isFetchingProposalDetail = false;
      })
      .addMatcher(GetProposalDetail.matchRejected, state => {
        state.proposalDetail = null;
        state.isFetchingProposalDetail = false;
      })
      .addMatcher(GetAllProposalTypes.matchPending, state => {
        state.proposalTypes = [];
        state.isFetchingProposalTypes = true;
      })
      .addMatcher(GetAllProposalTypes.matchFulfilled, (state, { payload }) => {
        state.proposalTypes = payload.data;
        state.isFetchingProposalTypes = false;
      })
      .addMatcher(GetAllProposalTypes.matchRejected, state => {
        state.proposalTypes = [];
        state.isFetchingProposalTypes = false;
      })
      .addMatcher(
        isAnyOf(
          GetProposalComments.matchPending,
          GetProposalComments.matchRejected
        ),
        state => {
          state.proposalComments = null;
        }
      )
      .addMatcher(GetProposalComments.matchFulfilled, (state, { payload }) => {
        state.proposalComments = payload;
      });
  },
});

export const { setProposalDetail } = proposalSlice.actions;
export const proposalReducer = proposalSlice.reducer;
